import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ContentSection } from './contentsection';
import { businessOrInvoiceContentSectionsPart1, businessOrInvoiceContentSectionsPart2, businessOrInvoiceContentSectionsPart3, businessOrInvoiceContentSectionsPart4, businessOrInvoiceContentSectionsPart5, businessOrInvoiceContentSectionsPart6, businessOrInvoiceContentSectionsPart7, businessOrInvoiceContentSectionsPart8, businessOrInvoiceContentSectionsPart9 } from '../constant/business-or-invoice-sections.constant';
import '../scss/business-or-invoice.style.scss';
import { businessImage1, businessImage2, bullseye, wink, paperplane, trophy } from './images/jpg/businessOrInvoiceImage';

const BusinessOrInvoicePageComponent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="business-or-invoice-page px-0">
            <section className="business-or-invoice-main-content px-0 mt-5">
                <Container >
                    <Row className="align-items-start">
                        <Col sm={6} className='px-0'>
                            <h2 className="Heading_h2">
                                {t('COMPARE_FORMS_OF_BUSINESS_SELF_EMPLOYED_OR_INVOZIO')}
                            </h2>
                        </Col>
                        <Col sm={6} className='px-0'>
                            <div className="main-content-description">
                                <p>{t('BUSINESS_OR_INVOICE_HERO_DESCRIPTION_PART_1')}</p>
                                <p>{t('BUSINESS_OR_INVOICE_HERO_DESCRIPTION_PART_2')}</p>
                                <p>{t('BUSINESS_OR_INVOICE_HERO_DESCRIPTION_PART_3')}</p>
                                <p>{t('BUSINESS_OR_INVOICE_HERO_DESCRIPTION_PART_4')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="business-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col >
                            <img src={businessImage1} alt="Business" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>
            {businessOrInvoiceContentSectionsPart1.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            {businessOrInvoiceContentSectionsPart2.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}
            {/* Benefits section with 4 cards */}
            <section className="benefits-section" style={{ marginBottom: '180px' }}>
                <Container >
                    <Row className="benefits-cards g-4" >
                        <Col xl={3} lg={6} md={6} sm={12} className="benefit-card">
                            <div className="benefit-header">
                                <div className="benefit-icon">
                                    <img src={bullseye} alt="Bullseye" />
                                </div>
                                <h5>{t('GET_ACCESS_TO_OUR_EXPERTISE')}</h5>
                            </div>
                            <p>{t('GET_ACCESS_TO_OUR_EXPERTISE_DESC')}</p>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} className="benefit-card">
                            <div className="benefit-header">
                                <div className="benefit-icon">
                                    <img src={wink} alt="Wink" />
                                </div>
                                <h5>{t('GET_HELP_WITH_NEGOTIATIONS')}</h5>
                            </div>
                            <p>{t('GET_HELP_WITH_NEGOTIATIONS_DESC')}</p>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} className="benefit-card">
                            <div className="benefit-header">
                                <div className="benefit-icon">
                                    <img src={paperplane} alt="PaperPlane" />

                                </div>
                                <h5>{t('ENJOY_MORE_FLEXIBILITY')}</h5>
                            </div>
                            <p>{t('ENJOY_MORE_FLEXIBILITY_DESC')}</p>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} className="benefit-card">
                            <div className="benefit-header">
                                <div className="benefit-icon">
                                    <img src={trophy} alt="Trophy" />
                                </div>
                                <h5>{t('FOR_BUSINESS_AND_INVOICING')}</h5>
                            </div>
                            <p>{t('FOR_BUSINESS_AND_INVOICING_DESC')}</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {businessOrInvoiceContentSectionsPart3.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}



            {businessOrInvoiceContentSectionsPart4.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            {businessOrInvoiceContentSectionsPart5.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            {businessOrInvoiceContentSectionsPart6.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            <section className="business-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col >
                            <img src={businessImage2} alt="Business" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>

            {businessOrInvoiceContentSectionsPart7.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            {businessOrInvoiceContentSectionsPart8.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            {businessOrInvoiceContentSectionsPart9.map((section: any, index: number) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey: string, textIndex: number) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}
        </div>
    );
};

export default BusinessOrInvoicePageComponent;
